<template>
  <div class="container mt--8 pb-5">
    <vue-progress-bar />
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-6">
        <div class="card bg-secondary shadow border-0">
          <!-- <div class="card-header bg-transparent pb-5">
            <div class="text-center mt-5">
              <img src="@/assets/app_logo.png" alt="Logo" width="50%" />
            </div>
          </div>-->
          <h1 class="text-center mt-6" style="color: white;">Reset Password</h1>
          <div class="card-body px-lg-5 py-lg-5">
            <form role="form">
              <span class="error" v-if="!email">* Email Required</span>
              <base-input
                class="input-group-alternative mb-3"
                placeholder="Email"
                addon-left-icon="ni ni-email-83"
                v-model="email"
                type="email"
                @input="onInputChanged()"
                @keyup="onKeyUp"
              ></base-input>
              <span class="error" v-if="!password">* Password Required</span>
              <base-input
                class="input-group-alternative"
                placeholder="New Password"
                type="password"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="password"
                @input="onInputChanged()"
                @keyup="onKeyUp"
              ></base-input>
              <div class="text-center">
                <base-button class="my-4 btn-login" @click="onSubmit()" :disabled="isLoading">Change</base-button>
              </div>
              <div class="text-center" v-if="errors">
                <span class="error">{{'* ' + errors }}</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { RESET_PASSWORD } from '@/store/actions.type'

export default {
  data() {
    return {
      email: null,
      password: null,
      isLoading: false
    }
  },
  methods: {
    onSubmit() {
      if (this.email && this.password) {
        const arr = window.location.href.split('/')
        const token = arr[arr.length - 1]
        this.isLoading = true
        this.$store
          .dispatch(RESET_PASSWORD, {
            token: token,
            email: this.email,
            password: this.password
          })
          .then(() => {
            this.$router.replace({ name: 'login' })
            this.isLoading = false
          })
          .catch(() => {
            this.isLoading = false
          })
      }
    },
    onKeyUp(e) {
      if (e.keyCode === 13) {
        this.onSubmit()
      }
    },
    onInputChanged() {
      this.$store.state.auth.errors = null
    }
  },
  computed: {
    ...mapState({
      errors: state => {
        return state.auth.errors
      }
    })
  }
}
</script>

<style scoped>
.container {
  margin-top: 150px !important;
}
.bg-secondary {
  background-color: #962100 !important;
}
.card-header {
  border-bottom: none !important;
}
.btn-login {
  color: #962100;
  background-color: white;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 2rem !important;
  border-color: transparent !important;
  padding-left: 50px;
  padding-right: 50px;
}
.btn-login:hover {
  color: #962100;
  background-color: white;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 2rem !important;
  border-color: transparent !important;
  padding-left: 50px;
  padding-right: 50px;
}
.btn-login:active:focus {
  color: #962100 !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 2rem !important;
  border-color: transparent !important;
  padding-left: 50px;
  padding-right: 50px;
}
.error {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

</style>
